<template>
  <div>
    <b-card>
      <!-- Button: Patient History -->
      <b-button
        variant="success"
        class="p-1 mb-1"
        block
        @click="
          $router.push({
            name: 'Reception-patient-history',
            params: { id2: patientData.id },
          })
        "
      >
        Patient History
      </b-button>
      <!-- Button: Create card -->

      <b-row>
        <b-col cols="6" md="6" sm="6">
          <!-- Button: Edit -->
          <b-button variant="outline-secondary" class="p-1" block>
            Edit
          </b-button>
        </b-col>
        <b-col cols="6" md="6" sm="6">
          <!-- Button: Delete -->
          <b-button variant="outline-secondary" class="p-1" block>
            Delete
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BCol, BButton } from 'bootstrap-vue';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
  },

  data() {
    return {};
  },
  mounted() {},

  methods: {},
};
</script>
